import { slideUp, slideDown, slideToggle } from "slide-animator";

var faqItems = document.querySelectorAll(".js-faq-item");

faqItems.forEach(function (faq) {
  var faqButtons = faq.querySelector(".js-faq-button");
  var faqContents = faq.querySelector(".js-faq-content");

  if (faqButtons && faqContents) {
    faqButtons.addEventListener("click", function () {
      slideToggle(faqContents);
      faq.classList.toggle("active");
    });
  }
});
